import { render, staticRenderFns } from "./InternalChat.vue?vue&type=template&id=71ffc416&scoped=true"
import script from "./InternalChat.vue?vue&type=script&lang=js"
export * from "./InternalChat.vue?vue&type=script&lang=js"
import style0 from "./InternalChat.vue?vue&type=style&index=0&id=71ffc416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ffc416",
  null
  
)

export default component.exports